import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchAllGetPortList = (data) => {
  // Accept optional search/page params like other list endpoints
  const searchCriteria = data?.searchCriteria || '';
  const Page = data?.Page || 1;
  const PageSize = data?.PageSize || 100;
  return axios.get(`${apiurl?.getPortList}?searchCriteria=${searchCriteria}&Page=${Page}&PageSize=${PageSize}`);
};

const getPortList = (data) => {
  return useQuery(['getPortList', data], () => fetchAllGetPortList(data), { refetchOnWindowFocus: false });
};

export default getPortList;
